<template>
  <div class="empty-layer-container">
    <div class="left-controls vh-100 d-flex f-column p-relative">
      <router-link to="/" class="logo-sm d-block">
        <svg id="Group_2445" data-name="Group 2445" xmlns="http://www.w3.org/2000/svg" width="50" height="51.24"
          viewBox="0 0 50 51.24">
          <path id="Path_14062" data-name="Path 14062"
            d="M15359.1,2836.146h10.182v-13.957h13.066v13.957h10.177V2792.63h-10.177v20.533H15359.1Z"
            transform="translate(-15342.526 -2784.906)" fill="#fefefc" />
          <path id="Path_14063" data-name="Path 14063"
            d="M15076.42,2645.32h-10.177v13.957h-13.066V2645.32H15043v43.516h10.177V2668.3h23.243Z"
            transform="translate(-15043 -2645.32)" fill="#ca9760" />
        </svg>
      </router-link>
      <div class="language-control">
        <Language />
      </div>
      <div class="call-control mt-auto">
        <span>Обратный звонок</span>
        <p class="m-0 text-white">+998 71 233 33 30</p>
      </div>
    </div>
    <div class="layer-control-text">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Выбор объекта</h1>
      </div>
    </div>

    <BottomNavigation />
    <TheNavigationMenu />

    <div class="object-area-view">
      <div class="object-area p-absolute w-100 vh-100">
        <div class="object-background h-100">
          <div class="object-svg p-relative vh-100">
            <div class="object-svg__container p-absolute hidden">
              <FacadePlanningCarousel :house_id="this.$route.params.house_id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavigationMenu from "../../../components/layout/TheNavigationMenu";
import BottomNavigation from "../../../components/layout/BottomNavigation";
import Language from "../../../components/Language";
import FacadePlanningCarousel from './FacadePlanningCarousel.vue';

export default {
  name: "FacedePlanningShoow",

  components: {
    TheNavigationMenu,
    Language,
    BottomNavigation,
    FacadePlanningCarousel
  }
};
</script>

<style>
.facade-plans {
  user-select: none;
}
</style>
